import { Tooltip } from '@mui/material';

import { StyleSheet } from '../../../types/list';

const styles: StyleSheet = {
  container: {
    fontSize: 12,
    padding: '5px',
    maxWidth: '20vw',
  },
  text: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
};

const ItemComponent = ({ name }: { name: string }) => {
  return (
    <div style={styles.container}>
      <Tooltip
        title={name}
        placement={'bottom'}
      >
        <div style={styles.text}>{name}</div>
      </Tooltip>
    </div>
  );
};

export default ItemComponent;
